import api from "./axios";

export const loginUser = async (
  email,
  password
) => {

  const formData =
    new FormData();

  formData.append(
    "email",
    email
  );

  formData.append(
    "password",
    password
  );

  const response =
    await api.post(
      "/users/login/",
      formData
    );

  return response.data;
};
export const logoutUser = async () => {
  try {
    const response = await api.post("/users/logout/");
    return response.data;
  } catch (error) {
    // Even if API fails, we should clear local storage
    console.warn("Logout API failed, but clearing local data");
    return null;
  }
};